import { render, staticRenderFns } from "./porposal-detail-research-center.vue?vue&type=template&id=6063f267&scoped=true&"
import script from "./porposal-detail-research-center.vue?vue&type=script&lang=ts&"
export * from "./porposal-detail-research-center.vue?vue&type=script&lang=ts&"
import style0 from "./porposal-detail-research-center.vue?vue&type=style&index=0&id=6063f267&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6063f267",
  null
  
)

export default component.exports